module.exports = __webpack_public_path__ + "img/characters.a1d906ea.png";